import React, { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import { UnitsContext } from '../../../../../Contexts/UnitsContext';
import DropDownSingle from '../../../../../Components/DropDownSingle';

import InputConfig from '../../../../../Components/InputConfig';
import { ADUNITS } from './constants';

//mui imports====
import { Box } from '@mui/system';
import useCommonStyles from '../../../../../commonStyles';
import Typography from '@mui/material/Typography';

import { Grid } from '@mui/material';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
//===============
import GeneralIconButton from '../../../../../Components/GeneralIconButton';

const {
	LABEL: { DEFAULT_UNIT, BACKFILL_UNIT, NO_MCM_UNIT },
	KEY: { DEFAULT_UNIT_KEY, BACKFILL_UNIT_KEY, NO_MCM_UNIT_KEY }
} = ADUNITS;

const PlatformLevelDFPAdunitConfig = ({ title, adUnitType, keyData, device, platform }) => {
	const commonStyleClasses = useCommonStyles();
	const useCommonStyleClasses = useCommonStyles();
	const deleteIconAccessControlName = `NETWORKDATA.DFPADUNITS.${device}.${adUnitType}.DELETEADUNIT_BUTTON`;
	const addIconAccessControlName = `NETWORKDATA.DFPADUNITS.${device}.${adUnitType}.ADDADUNIT_BUTTON`;
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	const {
		siteRawConfig,
		transformedGamIdsConfig,
		customParentToChildMappingConfig,
		dfpNetworkConfig
	} = useContext(UnitsContext);

	const { siteId, mcmId, gamId } = siteRawConfig;

	const sectionIdSubstring = rawConfig.videoSectionId.substring(0, 5);

	const adUnits = rawConfig[keyData + '.' + adUnitType]
		? rawConfig[keyData + '.' + adUnitType]
		: [];

	const getGamIdentifier = (gamCode) => {
		if (dfpNetworkConfig?.gamNetworks?.[gamCode]) {
			const gamIdentifier = dfpNetworkConfig.gamNetworks[gamCode].signifier;
			return gamIdentifier.replace(/\s+/g, '_');
		}
		return '';
	};

	const isDataPresent = (adUnitType, skipMcmCheck = false) => {
		if (!rawConfig.videoSectionId) {
			throw new Error('videoSectionId is missing in video section');
		}
		let videoSectionId = rawConfig['videoSectionId'];
		if (!siteId) {
			throw new Error(`The siteId is missing in video section : ${videoSectionId}`);
		}
		if (!skipMcmCheck && adUnitType !== NO_MCM_UNIT_KEY && !mcmId && !hasValidCustomMappingConfig()) {
			throw new Error(`Missing mcmId for video section: ${videoSectionId}`);
		}
		if (!gamId) {
			throw new Error(`The gamId is missing in video section : ${videoSectionId}`);
		}
		var gamIdPresentInTransformedGamIds = transformedGamIdsConfig.some(function (gamIdObj) {
			return gamIdObj.value === gamId;
		});

		if (!gamIdPresentInTransformedGamIds) {
			throw new Error(
				`The default gamId is missing in Conncted Gam Ids in video section : ${videoSectionId}`
			);
		}
	};
	/**
	 * Returns the MCM ID mapped to a given GAM ID.
	 *
	 * @param {string} gamId - The GAM ID to look up.
	 * @returns {string} The corresponding MCM ID if mapping exists; otherwise, returns the default mcmId.
	 */
	const getMappedMcmId = (gamId) => {
		if (hasValidCustomMappingConfig() && customParentToChildMappingConfig.mapping[gamId]) {
			return customParentToChildMappingConfig.mapping[gamId];
		}
		return mcmId;
	};
	/**
	 * Validates the custom parent to child mapping configuration
	 *
	 * @returns {boolean} True if the configuration is valid; otherwise, false.
	 */
	const hasValidCustomMappingConfig = () => {
		return (
			customParentToChildMappingConfig &&
			customParentToChildMappingConfig.enabled &&
			typeof customParentToChildMappingConfig.mapping === 'object' &&
			Object.keys(customParentToChildMappingConfig.mapping).length > 0
		);
	};
	/**
	 * @name getNewAdUnitNameAndCode
	 * @description This function can be used to get the adUnit object containing name and code based on the adUnitTupe
	 * @param {string} adUnitType - it is the adUnitType which is used to check which ad type object is require
	 * @param {number} counter - it is the count of the number of adunits present of specific adUnitType
	 * @returns {object} It returns the new adUnit object for specific adUnitType
	 */
	function getNewAdUnitNameAndCode(adUnitType, counter) {
		let adUnit = {};
		const gamIdentifier = getGamIdentifier(gamId);
		const gamIdentifierStr = gamIdentifier === '' ? '' : `_${getGamIdentifier(gamId)}`;

		switch (adUnitType) {
			case DEFAULT_UNIT_KEY:
				adUnit = {
					name: `ap_${siteId}_instream_${device}_${sectionIdSubstring}${gamIdentifierStr}_p${counter}`,
					gamCode: gamId,
					mcmId: getMappedMcmId(gamId),
					adUnitCode: ''
				};
				break;
			case BACKFILL_UNIT_KEY:
				adUnit = {
					name: `ap_${siteId}_instream_${device}_${sectionIdSubstring}${gamIdentifierStr}_backfill${counter}`,
					gamCode: gamId,
					mcmId: getMappedMcmId(gamId),
					adUnitCode: ''
				};
				break;
			case NO_MCM_UNIT_KEY:
				adUnit = {
					name: `ap_${siteId}_instream_${device}_${sectionIdSubstring}${gamIdentifierStr}_noMcm${counter}`,
					gamCode: gamId,
					mcmId: '',
					adUnitCode: ''
				};
				break;
			default:
				adUnit = {};
				break;
		}
		return adUnit;
	}

	/**
	 * @name addNewAdUnit
	 * @description This function is used to add to specific adUnitType
	 * @param {object[]} adUnits - it is the adUnits array of object in which we want to add a new adUnit
	 * @param {string} adUnitType - it is the adUnitType which is used to check which ad type object is require
	 */
	const addNewAdUnit = (adUnitType, adUnits) => {
		let updatedAdUnits = [];
		try {
			isDataPresent(adUnitType);
			const counter = adUnits.length + 1;

			const checkDefaultOrBackFillCondition =
				rawConfig &&
				rawConfig[keyData + '.' + adUnitType] &&
				Array.isArray(rawConfig[keyData + '.' + adUnitType]) &&
				(adUnitType === DEFAULT_UNIT_KEY || adUnitType === BACKFILL_UNIT_KEY);

			const checkAdUnitCondition =
				checkDefaultOrBackFillCondition || adUnitType === NO_MCM_UNIT_KEY;

			if (checkAdUnitCondition) {
				const newAdUnit = getNewAdUnitNameAndCode(adUnitType, counter);

				// Checking if noMcmUnits are present else setting an empty array
				let currentAdUnits = rawConfig[keyData + '.' + adUnitType] || [];
				currentAdUnits = structuredClone(currentAdUnits);
				updatedAdUnits = [...currentAdUnits, newAdUnit];
				let deepClonedRawConfig = structuredClone(rawConfig);
				updateRawConfig({
					...deepClonedRawConfig,
					[keyData + '.' + adUnitType]: updatedAdUnits
				});
			} else {
				alert(`${adUnitType} adUnitType not found in rawConfig`);
			}
		} catch (err) {
			alert(err.message);
			console.error(err);
		}
	};

	/**
	 * @name deleteUnits
	 * @description This function is used to delete a specific adunit from specific adUnitType
	 * @param {number} adIndex - it is the index of adUnit which is to be deleted
	 * @param {string} adUnitType - it is the adUnitType which is used to check which ad type object is require
	 */
	const deleteAdUnit = (adIndex, adUnitType) => {
		try {
			isDataPresent(adUnitType, true);
			if (
				rawConfig &&
				rawConfig[keyData + '.' + adUnitType] &&
				Array.isArray(rawConfig[keyData + '.' + adUnitType])
			) {
				let deepClonedRawConfig = structuredClone(rawConfig);
				let filteredAdUnits = [...deepClonedRawConfig[keyData + '.' + adUnitType]];
				filteredAdUnits = filteredAdUnits.filter((data, id) => id !== adIndex);
				updateRawConfig({
					...deepClonedRawConfig,
					[keyData + '.' + adUnitType]: filteredAdUnits
				});
			} else {
				alert(`Could'nt find ${adUnitType} adUnitType in rawConfig!`);
			}
		} catch (err) {
			alert(err.message);
			console.error(err);
		}
	};

	const updateUnits = (updatedValue, idx, field, value) => {
		const updatedInput = updatedValue;
		let deepClonedRawConfig = structuredClone(rawConfig);
		let filteredDefaultUnits = [...deepClonedRawConfig[keyData + '.' + field]];

		if (value === 'gamCode') {
			const oldGamCode = filteredDefaultUnits[idx].gamCode;

			const oldGamIdentifier = getGamIdentifier(oldGamCode);
			const currentGamIdentifier = getGamIdentifier(updatedInput);
			filteredDefaultUnits[idx].gamCode = updatedInput;

			if (field !== NO_MCM_UNIT_KEY) {
				filteredDefaultUnits[idx]['mcmId'] = getMappedMcmId(updatedValue);
			}

			const oldGamCodeStr = `_${oldGamIdentifier}_`;
			const currGamCodeStr = `_${currentGamIdentifier}_`;

			filteredDefaultUnits[idx].name = filteredDefaultUnits[idx].name.replace(
				oldGamCodeStr,
				currGamCodeStr
			);
		} else {
			filteredDefaultUnits[idx][value] = updatedInput;
		}

		updateRawConfig({
			...deepClonedRawConfig,
			[keyData + '.' + field]: filteredDefaultUnits
		});
	};

	return (
		<Box
			className={commonStyleClasses.basicOutlinedBox}
			style={{ margin: '0 auto 3rem auto', padding: '2rem 0 0rem 0', width: '97.5%' }}
		>
			<Typography fontWeight={600} variant="h4" style={{ marginLeft: '2rem' }}>
				{platform[0].toUpperCase() + platform.slice(1).toLowerCase()}
			</Typography>

			{adUnits.map((adUnit, adIndex) => {
				return (
					<Box
						className={commonStyleClasses.basicOutlinedBox}
						style={{ width: '97%' }}
						key={adIndex}
					>
						<Grid container spacing={2}>
							<Grid item xs={4}>
								<InputConfig
									isObjectEditor={false}
									directValue={adUnit.name}
									updateDirectValue={(updatedValue) =>
										updateUnits(updatedValue, adIndex, adUnitType, 'name')
									}
									label="Name"
									inputStyles={{ width: '100%', margin: '1rem 0' }}
									labelStyles={{ width: '100%' }}
									keyData={keyData + `.${adIndex}.name`}
								/>
							</Grid>
							{!adUnit.adUnitCode && (
								<Grid item xs={4}>
									<DropDownSingle
										isObjectEditor={false}
										directValue={adUnit.gamCode}
										updateDirectValue={(updatedValue) =>
											updateUnits(updatedValue, adIndex, adUnitType, 'gamCode')
										}
										list={transformedGamIdsConfig.map((gamObj) => gamObj.value)}
										label="GAM Code"
										formControlStyles={{ width: '100%' }}
										labelStyles={{ width: '100%' }}
										formControlVariant="outlined"
										keyData={keyData + `.${adIndex}.gamCode`}
									/>
								</Grid>
							)}
							{adUnit.adUnitCode && (
								<Grid item xs={4}>
									<InputConfig
										isObjectEditor={false}
										directValue={adUnit.gamCode}
										label="GAM Code"
										inputStyles={{ width: '100%', margin: '1rem 0' }}
										labelStyles={{ width: '100%' }}
										editable={false}
										keyData={keyData + `.${adIndex}.gamCode`}
									/>
								</Grid>
							)}
							{adUnitType !== NO_MCM_UNIT_KEY && (
								<Grid item xs={4}>
									<InputConfig
										isObjectEditor={false}
										directValue={adUnit.mcmId}
										label="MCM ID"
										inputStyles={{ width: '100%', margin: '1rem 0' }}
										labelStyles={{ width: '100%' }}
										editable={false}
										keyData={keyData + `.${adIndex}.mcmId`}
									/>
								</Grid>
							)}
							<Grid item xs={4}>
								<InputConfig
									isObjectEditor={false}
									directValue={adUnit.adUnitCode}
									label="AD Unit Code"
									inputStyles={{ width: '100%', margin: '1rem 0' }}
									labelStyles={{ width: '100%' }}
									editable={false}
									keyData={keyData + `.${adIndex}.adUnitCode`}
								/>
							</Grid>
							<Grid item xs={12}>
								<GeneralIconButton
									color="primary"
									onClick={() => deleteAdUnit(adIndex, adUnitType)}
									className={useCommonStyleClasses.icon}
									name={deleteIconAccessControlName}
								>
									<DeleteOutlinedIcon />
								</GeneralIconButton>
							</Grid>
						</Grid>
					</Box>
				);
			})}
			<Box sx={{ marginTop: '1rem', marginBottom: '2rem', textAlign: 'center' }}>
				<GeneralIconButton
					color="primary"
					fontSize="large"
					className={useCommonStyleClasses.icon}
					onClick={() => addNewAdUnit(adUnitType, adUnits)}
					name={addIconAccessControlName}
					disabled={!dfpNetworkConfig}
				>
					{!dfpNetworkConfig ? (
						<CircularProgress size={14} color="inherit" />
					) : (
						<AddCircleOutlineOutlinedIcon />
					)}
				</GeneralIconButton>
			</Box>
		</Box>
	);
};

export default PlatformLevelDFPAdunitConfig;
